module.exports = __webpack_public_path__ + "static/media/our-values-why-tech.2962e929.png";